//@ts-check

import React from "react";
// import { StyleSheet, Text, View } from "react-native";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Login from "../screens/Login";

import { connect, useSelector } from "react-redux";
import MainRouter from "./mainRouter";
import {
  AblyProvider,
  ChannelProvider,
  useChannel,
  useConnectionStateListener,
} from "ably/react";

const EntryRouter = (props) => {
  // const { analystId } = useSelector(
  //   (state) => ({
  //     analystId: state.auth.analyst_id,

  //   })
  // );
  const { isAuthenticated, analyst_id } = props;
  return (
    <ChannelProvider channelName={"analyst_portal_" + analyst_id}>
      <Router>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route
            path="/"
            render={({ location }) =>
              isAuthenticated ? (
                <MainRouter />
              ) : (
                <Redirect
                  to={{
                    pathname: "/login",
                    state: { from: location },
                  }}
                />
              )
            }
          />
        </Switch>
      </Router>
    </ChannelProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    analyst_id: state.auth.analyst_id,
  };
};

export default connect(mapStateToProps, {})(EntryRouter);
